"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-colombano-certenoli": {
    "84e5597e": [{
      "hkey": "771c014e",
      "slug": "aveggio-chiesa-nuova-maggi",
      "name": "Aveggio-Chiesa Nuova-Maggi",
      "primary": true,
      "skipSearch": false
    }],
    "aveggio": [{
      "hkey": "771c014e",
      "slug": "aveggio-chiesa-nuova-maggi",
      "name": "Aveggio-Chiesa Nuova-Maggi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-colombano-certenoli"
    }],
    "a77a5cba": [{
      "hkey": "c7e54c04",
      "slug": "san-colombano-bavaggi-perella",
      "name": "San Colombano-Bavaggi-Perella",
      "primary": true,
      "skipSearch": false
    }],
    "bavaggi": [{
      "hkey": "c7e54c04",
      "slug": "san-colombano-bavaggi-perella",
      "name": "San Colombano-Bavaggi-Perella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-colombano-certenoli"
    }],
    "54abc8cd": [{
      "hkey": "771c014e",
      "slug": "aveggio-chiesa-nuova-maggi",
      "name": "Aveggio-Chiesa Nuova-Maggi",
      "primary": true,
      "skipSearch": false
    }],
    "chiesa-nuova-maggi-perella": [{
      "hkey": "771c014e",
      "slug": "aveggio-chiesa-nuova-maggi",
      "name": "Aveggio-Chiesa Nuova-Maggi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ba87dbee": [{
      "hkey": "c7e54c04",
      "slug": "san-colombano-bavaggi-perella",
      "name": "San Colombano-Bavaggi-Perella",
      "primary": true,
      "skipSearch": false
    }],
    "san-colombano": [{
      "hkey": "c7e54c04",
      "slug": "san-colombano-bavaggi-perella",
      "name": "San Colombano-Bavaggi-Perella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "eaf36f6b": [{
      "hkey": "4c3f7e9a",
      "slug": "cichero-villagrande",
      "name": "Cichero-Villagrande",
      "primary": true,
      "skipSearch": false
    }],
    "5ff448d5": [{
      "hkey": "4c3f7e9a",
      "slug": "cichero-villagrande",
      "name": "Cichero-Villagrande",
      "primary": true,
      "skipSearch": false
    }],
    "cichero": [{
      "hkey": "4c3f7e9a",
      "slug": "cichero-villagrande",
      "name": "Cichero-Villagrande",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7fa9a0ee": [{
      "hkey": "771c014e",
      "slug": "aveggio-chiesa-nuova-maggi",
      "name": "Aveggio-Chiesa Nuova-Maggi",
      "primary": true,
      "skipSearch": false
    }],
    "maggi": [{
      "hkey": "771c014e",
      "slug": "aveggio-chiesa-nuova-maggi",
      "name": "Aveggio-Chiesa Nuova-Maggi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "241a0dfe": [{
      "hkey": "47d11cb4",
      "slug": "mezzavalle-piane-pregi",
      "name": "Mezzavalle-Piane-Pregi",
      "primary": true,
      "skipSearch": false
    }],
    "mezzavalle": [{
      "hkey": "47d11cb4",
      "slug": "mezzavalle-piane-pregi",
      "name": "Mezzavalle-Piane-Pregi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "9ee459b1": [{
      "hkey": "f2584853",
      "slug": "san-martino",
      "name": "San Martino",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino-al-monte": [{
      "hkey": "f2584853",
      "slug": "san-martino",
      "name": "San Martino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "cichero-villarande": [{
      "hkey": "4c3f7e9a",
      "slug": "cichero-villagrande",
      "name": "Cichero-Villagrande",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b4969511": [{
      "hkey": "771c014e",
      "slug": "aveggio-chiesa-nuova-maggi",
      "name": "Aveggio-Chiesa Nuova-Maggi",
      "primary": true,
      "skipSearch": false
    }],
    "chiesa-nuova": [{
      "hkey": "771c014e",
      "slug": "aveggio-chiesa-nuova-maggi",
      "name": "Aveggio-Chiesa Nuova-Maggi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;